/**
 * Pure helpers for the Notifications form (`/api/settings/proactive`, stored
 * as a partial overlay): only changed top-level keys are sent, and the tax
 * rate is edited as a percentage but stored as a fraction.
 */
import type { ProactiveSettings } from './types.js';

/** The top-level keys whose value differs between `before` and `after`. */
export function settingsPatch(before: ProactiveSettings, after: ProactiveSettings): Partial<ProactiveSettings> {
  const patch: Partial<Record<keyof ProactiveSettings, unknown>> = {};
  for (const key of Object.keys(after) as (keyof ProactiveSettings)[]) {
    if (JSON.stringify(after[key]) !== JSON.stringify(before[key])) patch[key] = after[key];
  }
  return patch as Partial<ProactiveSettings>;
}

/** 0.3 → '30'. */
export function rateToPercent(rate: number): string {
  return String(Math.round(rate * 1000) / 10);
}

/** '30' → 0.3; null unless 0–100. */
export function percentToRate(raw: string): number | null {
  const n = Number(raw.trim());
  if (raw.trim() === '' || !Number.isFinite(n) || n < 0 || n > 100) return null;
  return Math.round(n * 10) / 1000;
}

/** 'HH:MM' 24-hour, as `<input type="time">` produces and the server stores. */
export function isClock(s: string): boolean {
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(s);
}
